const { PeerReviewStatus } = require('peer-review-status');

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.peerReviewStatus', deps)
  .directive('peerReviewStatus', reactDirective =>
    reactDirective(PeerReviewStatus, ['clientId'], {}, {}),
  );
